/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimezoneMetadata
 */
export interface TimezoneMetadata {
    /**
     * 
     * @type {string}
     * @memberof TimezoneMetadata
     */
    timestampTimezone?: string;
    /**
     * 
     * @type {string}
     * @memberof TimezoneMetadata
     */
    userTimezone?: string;
    /**
     * 
     * @type {string}
     * @memberof TimezoneMetadata
     */
    timezoneInfo?: string;
}

/**
 * Check if a given object implements the TimezoneMetadata interface.
 */
export function instanceOfTimezoneMetadata(value: object): value is TimezoneMetadata {
    return true;
}

export function TimezoneMetadataFromJSON(json: any): TimezoneMetadata {
    return TimezoneMetadataFromJSONTyped(json, false);
}

export function TimezoneMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimezoneMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'timestampTimezone': json['timestamp_timezone'] == null ? undefined : json['timestamp_timezone'],
        'userTimezone': json['user_timezone'] == null ? undefined : json['user_timezone'],
        'timezoneInfo': json['timezone_info'] == null ? undefined : json['timezone_info'],
    };
}

export function TimezoneMetadataToJSON(json: any): TimezoneMetadata {
    return TimezoneMetadataToJSONTyped(json, false);
}

export function TimezoneMetadataToJSONTyped(value?: TimezoneMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timestamp_timezone': value['timestampTimezone'],
        'user_timezone': value['userTimezone'],
        'timezone_info': value['timezoneInfo'],
    };
}

